import { observable, makeObservable } from 'mobx'
import moment from 'moment'
require('moment/locale/en-gb.js')
require('moment/locale/es.js')
require('moment/locale/ru.js')

export const APP_LANGUAGES = {
  RU: 'ru',
  EN: 'en',
  ES: 'es'
}

export class LocaleStore {
  constructor () {
    makeObservable(this, {
      _locale: observable
    })

    this.locale = sessionStorage.getItem('locale') || APP_LANGUAGES.RU
  }

  _locale = null

  set locale (locale) {
    this._locale = locale
    moment.locale(locale)
    sessionStorage.setItem('locale', locale)
  }

  get locale () {
    return this._locale
  }
}
